class Style {
  /**
   * Get the computed styles for the given element.
   * @param {Element} element The element to get computed styles for
   */
  static getComputed(element) {
    if (isset(element.currentStyle)) {
      return element.currentStyle;
    } else if (isset(window.getComputedStyle)) {
      return document.defaultView.getComputedStyle(element,null);
    } else {
      return undefined;
    }
  }

  /**
   * Get the computed styles for the given element.
   * @param {Element} element The element to get computed styles for
   * @param {string} property The style property name to retrieve the value for
   */
  static getComputedProperty(element, property) {
    return Style.getComputed(element).getPropertyValue(property);
  }
}
